package app.bloomey.web.components.layouts

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.remember
import app.bloomey.web.components.widgets.LoadingView
import app.bloomey.web.core.data.SessionManager
import app.bloomey.web.core.res.Res
import app.bloomey.web.core.res.login
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxSize
import com.varabyte.kobweb.core.rememberPageContext

@Composable
fun AuthGuard(content: @Composable () -> Unit) {
    val context = rememberPageContext()
    val authenticated = remember { SessionManager.signedIn }
    LaunchedEffect(Unit) {
        try {
            if (!authenticated)
                context.router.navigateTo(Res.Destinations.login)
        } catch (e: Exception) {
            println(e)
        }
    }

    if (authenticated)
        content()
    else
        Box(modifier = Modifier.fillMaxSize(), contentAlignment = Alignment.Center) {
            LoadingView()
        }
}